export default (function sliderInit() {
    // tuningSlider () {
    //     const tab = window.matchMedia('(max-width: 1179px)');
    //     const xlSlider = $('.js--xl-slider');
    //     function toogleSwitcher(tab) {
    //         if (tab.matches) {
    //             if (xlSlider.hasClass('slick-initialized')) {
    //                 xlSlider.slick('unslick');
    //             }
    //         } else {
    //             slider.xlSliderInit();
    //         }
    //     }
    //     toogleSwitcher(tab);
    //     tab.addEventListener('change', () => toogleSwitcher(tab));
    // },

    const slider = {
        xlSliderInit() {
            $('.js--xl-slider').slick({
                slidesToShow: 4,
                slidersToScroll: 4,
                infinite: false,
                arrows: true,
                variableWidth: true,
                nextArrow: '<div class="btn btn--small btn--white js--slider-next slider-controls">\n'
                    + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                    + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                    + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                    + '            </svg>\n'
                    + '    </div>',
                prevArrow: '<div class="btn btn--small btn--white btn--prev js--slider-prev slider-controls">\n'
                    + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                    + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                    + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                    + '            </svg>\n'
                    + '    </div>',
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: false,
                            infinite: false,
                            variableWidth: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        },
// slick-slider to schoolchildren category
        schoolchildren() {
            const slider = $('.js--category-container');
            const slides = $('.category-item');
            if (slides.length > 60) {
                slider.slick({
                    // slidesToShow: 1.06,
                    slidesToScroll: 1,
                    variableWidth: true,
                    infinite: false,
                    fade: false,
                    arrows: false,
                    dots: true,
                    nextArrow: $('.js--school_category_next'),
                    prevArrow: $('.js--school_category_prev'),
                    responsive: [
                        {
                            breakpoint: 1800,
                            settings: {
                                arrows: true,
                            },
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                arrows: false,
                            },
                        },
                        // {
                        //     breakpoint: 768,
                        //     settings: {
                        //         arrows: false,
                        //     },
                        // },

                    ],
                });
                // Спочатку ховаємо стрілку "назад"
                $('.js--school_category_prev').hide();

                // Відстежуємо зміну слайдів для контролю стрілок
                slider.on('afterChange', function (event, slick, currentSlide) {
                    const windowWidth = $(window).width(); // Отримуємо ширину екрану

                    if (windowWidth >= 1200) { // Логіка показу стрілок тільки для великих екранів
                        if (currentSlide === 0) {
                            $('.js--school_category_prev').fadeOut(); // Ховаємо "назад" на першому слайді
                        } else {
                            $('.js--school_category_prev').fadeIn();
                        }

                        if (currentSlide === slick.slideCount - 1) {
                            $('.js--school_category_next').fadeOut(); // Ховаємо "вперед" на останньому слайді
                        } else {
                            $('.js--school_category_next').fadeIn();
                        }
                    } else {
                        $('.js--school_category_prev, .js--school_category_next').hide(); // Ховаємо стрілки при менших екранах
                    }
                });

                // Перевіряємо ширину екрану при завантаженні
                $(window).on('resize', function () {
                    const windowWidth = $(window).width();
                    if (windowWidth < 1200) {
                        $('.js--school_category_prev, .js--school_category_next').hide();
                    }
                }).trigger('resize'); // Викликаємо подію одразу при завантаженні
            }
        },

        reltedProductsInit() {
            const $reltedProductsSlick = $('.js--reltedProductsInit');
            // const $counter = $('.blockproductscategory .js--counter');
            // const slidesCount = 3;
            //
            // $reltedProductsSlick.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
            //     const i = (currentSlide || 0) + 1;
            //
            //     $counter.text(`${Math.ceil(i / slidesCount)} / ${Math.ceil(slick.slideCount / slidesCount)}`);
            // });
            function initializeSlider() {
                $reltedProductsSlick.slick({
                    slidesToShow: 4,
                    slidersToScroll: 4,
                    infinite: true,
                    arrows: true,
                    variableWidth: true,
                    dots: true,
                    nextArrow: '<div class="btn btn--small btn--white js--slider-next slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                    prevArrow: '<div class="btn btn--small btn--white btn--prev js--slider-prev slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 1,
                                slidersToScroll: 1,
                            },
                        },
                    ],
                });
            }
            function destroySlider() {
                if ($reltedProductsSlick.hasClass('slick-initialized')) {
                    $reltedProductsSlick.slick('unslick');
                }
            }

            function checkWindowSize() {
                const windowWidth = $(window).width();
                if (windowWidth < 768) {
                    destroySlider();
                } else if (!$reltedProductsSlick.hasClass('slick-initialized')) {
                    initializeSlider();
                }
            }
                checkWindowSize();
            $(window).resize(function () {
                checkWindowSize();
            });
        },
        similar_discoverInit() {
            const $similarDiscoverSlick = $('.js--similar_discover');
            // const $counter = $('.blockproductscategory .js--counter');
            // const slidesCount = 3;
            //
            // $reltedProductsSlick.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
            //     const i = (currentSlide || 0) + 1;
            //
            //     $counter.text(`${Math.ceil(i / slidesCount)} / ${Math.ceil(slick.slideCount / slidesCount)}`);
            // });
            function initializeSlider() {
                $similarDiscoverSlick.slick({
                    slidesToShow: 4,
                    slidersToScroll: 4,
                    infinite: true,
                    arrows: true,
                    variableWidth: true,
                    dots: true,
                    nextArrow: '<div class="btn btn--small btn--white js--slider-next slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                    prevArrow: '<div class="btn btn--small btn--white btn--prev js--slider-prev slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                variableWidth: true,
                                infinite: true,
                                slidesToShow: 1,
                                slidersToScroll: 1,
                            },
                        },
                    ],
                });
            }

            function destroySlider() {
                if ($similarDiscoverSlick.hasClass('slick-initialized')) {
                    $similarDiscoverSlick.slick('unslick');
                }
            }
            function checkWindowSize() {
                const windowWidth = $(window).width();
                if (windowWidth < 768) {
                    destroySlider();
                } else if(!$similarDiscoverSlick.hasClass('slick-initialized')) {
                    initializeSlider();
                }
            }
            checkWindowSize();
            $(window).resize(function () {
                checkWindowSize();
            });
        },
        // slick-slider to homeSlider module, use on index page
        homeInit() {
            $('.js--home_slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: 5000,
                fade: true,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            dots: false,
                        },
                    },
                ],
            });
        },

        // slick-slider to homefeatured module, use on index page
        interestingInit() {
            $('.js--interesting_slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: 5000,
                fade: true,
                nextArrow: $('.js--interesting_next'),
                prevArrow: $('.js--interesting_prev'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                        },
                    },
                ],

            });
        },

        // slick-slider to posnewproducts module, use on index page
        newProdInit() {
            const $slickElement = $('.js--new_prod');
            const $counter = $('.new_products .js--counter');
            const slidesCount = 4;

            $slickElement.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
                const i = (currentSlide || 0) + 1;

                $counter.text(`${Math.ceil(i / slidesCount)} / ${Math.ceil(slick.slideCount / slidesCount)}`);
            });


            $slickElement.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                variableWidth: true,
                nextArrow: $('.js--new_arrows_next'),
                prevArrow: $('.js--new_arrows_prev'),
                dots: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            dots: false,
                            variableWidth: false,
                            slidesToShow: slidesCount,
                            slidesToScroll: slidesCount,
                        },
                    },
                ],
            });
        },

        // slick-slider to smattblog module, use on index page
        blogInit() {
            const $slickElement = $('.js--blog');
            const $counter = $('.blog .js--counter');
            const slidesCount = 3;

            $slickElement.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
                const i = (currentSlide || 0) + 1;

                $counter.text(`${Math.ceil(i / slidesCount)} / ${Math.ceil(slick.slideCount / slidesCount)}`);
            });


            $slickElement.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                variableWidth: true,
                nextArrow: $('.js--blog_arrows_next'),
                prevArrow: $('.js--blog_arrows_prev'),
                dots: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            dots: false,
                            variableWidth: false,
                            slidesToShow: slidesCount,
                            slidesToScroll: slidesCount,
                        },
                    },
                ],
            });
        },

        sertificatesInit() {
            const $sertificatesSlick = $('.js--sertificates');

            function initializeSlider() {
                $sertificatesSlick.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    variableWidth: true,
                    dots: true,
                    nextArrow: '<div class="btn btn--small btn--white js--slider-next slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                    prevArrow: '<div class="btn btn--small btn--white btn--prev js--slider-prev slider-controls">\n'
                        + '        <svg version="1.1" class="btn__arrow arrow--orange" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 12" enable-background="new 0 0 17 12" xml:space="preserve">\n'
                        + '                <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1l5,5l-5,5"/>\n'
                        + '            <path fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1,6h15"/>\n'
                        + '            </svg>\n'
                        + '    </div>',
                });
            }
            function destroySlider() {
                if ($sertificatesSlick.hasClass('slick-initialized')) {
                    $sertificatesSlick.slick('unslick');
                }
            }

            function checkWindowSize() {
                const windowWidth = $(window).width();
                if (windowWidth > 768) {
                    destroySlider();
                } else if (!$sertificatesSlick.hasClass('slick-initialized')) {
                    initializeSlider();
                }
            }
            checkWindowSize();
            $(window).resize(function () {
                checkWindowSize();
            });
        },


        // slick-slider to product page
        productInit() {
            const $slickElement = $('.js--prod_main');
            const $slickThumbnail = $('.js--prod_thumb');
            if ($slickThumbnail.find('.product_sliders__thumb_item').length <= 4) {
                $('.product_sliders__thumb').addClass('stop_scroll');
            }
            $slickElement.slick({
                asNavFor: $slickThumbnail,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                nextArrow: $('.js--product_next'),
                prevArrow: $('.js--product_prev'),
                dots: true,
                arrows: false,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            dots: false,
                            arrows: true,
                        },
                    },
                ],
            });
            $slickThumbnail.slick({
                asNavFor: $slickElement,

                slidesToShow: 4,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                focusOnSelect: true,

                // responsive: [
                //   {
                //     breakpoint: 768,
                //     settings: {
                //       dots: false,
                //     },
                //   },
                //   {
                //     breakpoint: 1200,
                //     settings: {
                //       dots: false,
                //       variableWidth: false,
                //       slidesToShow: slidesCount,
                //       slidesToScroll: slidesCount,
                //     },
                //   },
                // ]
            });
        },
    };

    $(document).ready(() => {
        slider.schoolchildren();
        slider.xlSliderInit();
        slider.homeInit();
        slider.interestingInit();
        slider.newProdInit();
        slider.blogInit();
        slider.productInit();
        slider.reltedProductsInit();
        slider.similar_discoverInit();
        slider.sertificatesInit();
    });
})();
